// extracted by mini-css-extract-plugin
export default {"fullWidth":"fp-z","image":"gp-z","lazyLoadPicture":"hp-z","lazyLoadSpinner":"ip-z","lazyLoadSpin":"jp-z","lazyLoadImage":"kp-z","hasStyledAspectRatio":"lp-z"};